// extracted by mini-css-extract-plugin
module.exports = {"navLink":"TopRightButton_navLink__2lsVs"};